import type { IAppState } from 'services/app-state-provider';
import { ChatsEntitiesActions } from 'store/entities/chats/actions';

import type { IEventDeletedPushEvent } from '../interfaces';

/**
 * Handles event deleted push event.
 * Marks the specified event as deleted in the local state.
 * @param {IEventDeletedPushEvent} payload Push event payload.
 * @param {IAppState} store Redux store.
 */
export function handleEventDeleted(payload: IEventDeletedPushEvent, store: IAppState): void {
  const { chat_id: chatId, thread_id: threadId, event_id: eventId } = payload;

  store.dispatch(
    ChatsEntitiesActions.deleteEvent({
      chatId,
      threadId,
      eventId,
    }),
  );
}
